import * as Yup from 'yup';
import {
    validateAmount,
    validateNumber,
    validateOptionalNumber,
} from "@/Shared/Helpers";

export type AgentTargetFormValues = {
    id: number;
    agentId: number;
    year: number;

    rentalTarget?: number;
    salesTarget?: number;
    otherProductsTarget?: number;
    caTarget?: string;
    mandatesTarget?: number;
};

export const AgentTargetValidationSchema = () => 
    Yup.object<AgentTargetFormValues>({
        id: validateOptionalNumber(),

        agentId: validateOptionalNumber().required('L’agent est requis.'),

        year: validateNumber()
            .required('L’année est requise.')
            .min(2000, 'Année invalide')
            .max(new Date().getFullYear() + 5, 'Année invalide'),

        rentalTarget: validateOptionalNumber().min(0, 'Doit être positif'),
        salesTarget: validateOptionalNumber().min(0, 'Doit être positif'),
        otherProductsTarget: validateOptionalNumber().min(0, 'Doit être positif'),
        caTarget: validateAmount('Doit être un entier positif valide.'),
        mandatesTarget: validateOptionalNumber().min(0, 'Doit être positif'),
    });
